import get from 'lodash/get';
import showNotification from '../../../actions/show-notification';

function beforeRequest(actionContext) {
	actionContext.dispatch('CREATE_APPENDAGE_START');
}

function onSuccess(actionContext, { response: { data } }) {
	const ConfigSettingsStore = actionContext.getStore('ConfigSettingsStore');
	const configSettings = ConfigSettingsStore.getConfigSettings();

	actionContext.dispatch('CREATE_APPENDAGE_FINISH', { data, configSettings });
}

function onFailed(actionContext, { response }) {
	actionContext.executeAction(showNotification, {
		heading: 'Error Uploading Document',
		message: 'Unable to upload document. Please try again',
		color: 'danger',
	});

	actionContext.dispatch('CREATE_APPENDAGE_FAILED', response.statusText);
}

export default (config) => ({
	serviceName: 'createAppendage',
	config: {
		method: 'POST',
		url: get(config, 'endpoints.missingPersons.searches.createAppendage'),
	},
	beforeRequest,
	onSuccess,
	onFailed,
	onError: onFailed,
	onTimeout: onFailed,
	onFatal: onFailed,
});
